import {
  init,
  loaderRunner,
  redirectToUserPrefix,
  termsOfService,
  userChecks,
} from "./helpers";
export const guestLoader = async () => {
  return loaderRunner([
    await init(),
    await userChecks(),
    termsOfService(),
    await redirectToUserPrefix("/guest"),
  ]);
};
